import React from "react";
import { CardWrapper, CardLabel, CardValue, CardUnit } from "./Card.styled";
import { formatNumber } from "../../../utils/numberFormat";

/**
 * Metric card with label, large value, and optional unit.
 *
 * @param {string} label  — heading label
 * @param {number} value  — numeric value
 * @param {string} [unit] — unit label
 * @param {string} accent — accent color for label & border tint
 * @param {string} bg     — background color
 */
const StatCard = ({ label, value, unit, accent, bg }) => (
  <CardWrapper $bg={bg} $accent={accent}>
    <CardLabel $accent={accent}>{label}</CardLabel>
    <CardValue>{value != null ? formatNumber(value) : 0}</CardValue>
    {unit && <CardUnit>{unit}</CardUnit>}
  </CardWrapper>
);

export default StatCard;
